import { clsx } from 'external/clsx'
import {Card, FC, PropsWithChildren, useMemo} from 'external/react'
import Icon, { IconName } from 'external/fortawesome'

import ButtonBack from 'components/ButtonBack'
import BasicLayout from './BasicLayout'
import useAdmin from 'context/admin-context/hook'

type HeadingProps = [IconName, string] 
type HomePages = [ 'home', 'support', 'packages', 'payment' ]
type PageName = HomePages[number] 

type HeadingsMap = {
	[Key in PageName]: HeadingProps
}

const parentContainerHeadings: HeadingsMap = {
  home: ['faHouse', 'Home'],
	support: ['faHeadset', 'Apoyo'],
	packages: ['faBox', 'Mis Paquetes'],
	payment: ['faHandHoldingDollar', 'Pagos']
}

const HomeContainer: FC<PropsWithChildren> = props => {

    const {children} = props
	const {params} = useAdmin()

	const [icon, label] = useMemo(() => (parentContainerHeadings[params.pageName || 'home'] || parentContainerHeadings.home) as HeadingProps, [params.pageName])

    return (
		<BasicLayout>
			<Card.Header style={{ fontSize: '31px' }} className='card--header'>
			<ButtonBack path='/home' className={clsx({'d-none': label === 'Home'})} />
			<Icon name={icon} /> {label}
			</Card.Header>
			{children} 
		</BasicLayout>
	)
}

export {HomeContainer as default}